import { render, staticRenderFns } from "./TK303.vue?vue&type=template&id=a252e2b0"
import script from "./TK303.vue?vue&type=script&lang=js"
export * from "./TK303.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports